import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import StoreSelection from "@/pages/StoreSelection";
import BookingPage from "@/pages/BookingPage";
import CancelBookingPage from "@/pages/CancelBookingPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminStores from "@/pages/admin/AdminStores";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminContent from "@/pages/admin/AdminContent";
import AdminFeedback from "@/pages/admin/AdminFeedback";
import AdminCampaigns from "@/pages/admin/AdminCampaigns";
import AdminDiagnostics from "@/pages/admin/AdminDiagnostics";
import AdminProducts from "@/pages/admin/AdminProducts";
import OwnerLogin from "@/pages/owner/OwnerLogin";
import OwnerDashboard from "@/pages/owner/OwnerDashboard";
import FeedbackPage from "@/pages/FeedbackPage";
import { AuthProvider } from "@/contexts/AuthContext";
import { SiteContentProvider } from "@/contexts/SiteContentContext";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <SiteContentProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<StoreSelection />} />
                            <Route path="/negozio/:slug" element={<BookingPage />} />
                            <Route path="/annulla/:token" element={<CancelBookingPage />} />
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route path="/admin" element={<AdminLayout />}>
                                <Route index element={<AdminDashboard />} />
                                <Route path="stores" element={<AdminStores />} />
                                <Route path="bookings" element={<AdminBookings />} />
                                <Route path="feedback" element={<AdminFeedback />} />
                                <Route path="campagne" element={<AdminCampaigns />} />
                                <Route path="prodotti" element={<AdminProducts />} />
                                <Route path="diagnostica" element={<AdminDiagnostics />} />
                                <Route path="contenuti" element={<AdminContent />} />
                            </Route>
                            <Route path="/rivenditore/login" element={<OwnerLogin />} />
                            <Route path="/rivenditore" element={<OwnerDashboard />} />
                            <Route path="/feedback/:token" element={<FeedbackPage />} />
                        </Routes>
                    </BrowserRouter>
                </SiteContentProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
